import { createRouter } from "@tanstack/react-router";
import { QueryClient } from "@tanstack/query-core";
import { routeTree } from "./routeTree.gen";
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query";

export function getRouter() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: Infinity,
        refetchOnWindowFocus: false,
      },
    },
  });

  // @ts-expect-error TanStack Router v1.169 demands strictNullChecks; suppressed until codebase-wide null-safety cleanup
  const router = createRouter({
    routeTree,
    scrollRestoration: true,
    context: { queryClient },
    defaultSsr: false,
  });

  setupRouterSsrQueryIntegration({ router, queryClient });

  return router;
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>;
  }
}
